import { Banner } from '@airbus/components-react';
import Spinners from '../../shared/components/Spinner';
import GridTable from '../../shared/components/grid/GridTable';
import Layout from '../../shared/components/layout';
import useFetchScreenDetails from '../../shared/utils/useFetchScreenDetails';

import GetAllColumnContextProvider from '../../shared/context/GetAllColumnContext';
import { t } from '../../i18next';
import { useAllScreensContext } from '../../shared/context/AllScreensDetailsContext';
import { useNavigate, useParams } from 'react-router';

const AdminDefaultPage = () => {
  const { menuGroup } = useAllScreensContext();
  const navigate = useNavigate();
  const { screenId } = useParams();
  const { loading, error, screenTables } = useFetchScreenDetails(screenId);
  const onlyAdminScreeens = menuGroup
    .filter((item) => item.appName === 'NPI Tool Administration')
    .find((item) => item.subMenu.find((i) => i.appNameId === screenId));
  if (!onlyAdminScreeens && menuGroup.length) {
    navigate('/404');
    return;
  }

  return (
    <>
      {loading ? (
        <Spinners />
      ) : (
        <Layout>
          {error && <Banner variant='warning'>{t('data_not_available')}</Banner>}
          {!screenTables
            ? null
            : screenTables.map((item) => (
                <GetAllColumnContextProvider key={item.id}>
                  <GridTable tableRes={item} />
                </GetAllColumnContextProvider>
              ))}
        </Layout>
      )}
    </>
  );
};

export default AdminDefaultPage;
